// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../core/Env.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as Json from "../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../core/Request.res.js";
import * as DateHelpers from "../helpers/DateHelpers.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

let values = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

function isEqual(a, b) {
  switch (a) {
    case "January" :
      return b === "January";
    case "February" :
      return b === "February";
    case "March" :
      return b === "March";
    case "April" :
      return b === "April";
    case "May" :
      return b === "May";
    case "June" :
      return b === "June";
    case "July" :
      return b === "July";
    case "August" :
      return b === "August";
    case "September" :
      return b === "September";
    case "October" :
      return b === "October";
    case "November" :
      return b === "November";
    case "December" :
      return b === "December";
  }
}

function toDateMonthJsIndex(value) {
  return Stdlib_Option.getExn(Stdlib_Array.findIndexOpt(values, item => value === item), undefined);
}

function toSelectItem(value) {
  return {
    TAG: "Option",
    key: I18n.t(value),
    label: I18n.t(value),
    value: value
  };
}

function decodeFromJson(json) {
  return Stdlib_Option.flatMap(Json.decodeNumber(json), monthJsIndex => values[monthJsIndex | 0]);
}

function encodeToJson(value) {
  return Json.encodeNumber(toDateMonthJsIndex(value));
}

function request(shopId) {
  let endpoint = shopId => Env.gatewayUrl() + "/accounting-export-configurations/" + shopId;
  let decodeRequestError = param => {};
  let decodeResponse = response => Stdlib_Option.map(Json.decodeDict(response), dict => Stdlib_Option.flatMap(dict["fiscalYearOpeningMonth"], decodeFromJson));
  return Future.mapError(Future.mapOk(Request.make(endpoint(shopId), undefined, undefined, undefined, undefined), undefined, decodeResponse), undefined, decodeRequestError);
}

function fromLowercaseString(value) {
  return values.find(month => month.toLowerCase() === value.trim().toLowerCase());
}

function toLowercaseString(value) {
  return value.toLowerCase();
}

function currentFiscalYearPeriod(nowOpt, endClosingMonth) {
  let now = nowOpt !== undefined ? nowOpt : new Date();
  let monthIndex = toDateMonthJsIndex(endClosingMonth);
  let endYear = now.getFullYear() + (
    now.getMonth() > monthIndex ? 1 : 0
  ) | 0;
  let startDate = new Date(endYear - 1 | 0, monthIndex + 1 | 0, 1);
  let endDate = DateHelpers.endOfMonth(new Date(endYear, monthIndex, 1));
  return [
    startDate,
    endDate
  ];
}

export {
  values,
  isEqual,
  toDateMonthJsIndex,
  toSelectItem,
  decodeFromJson,
  encodeToJson,
  request,
  fromLowercaseString,
  toLowercaseString,
  currentFiscalYearPeriod,
}
/* I18n Not a pure module */
